import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';

import { Pf16Service } from 'src/app/services/pf16.service';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { TestService } from 'src/app/services/test.service';
declare var $:any;
declare var jQuery:any;

@Component({
  selector: 'app-pf16',
  templateUrl: './pf16.component.html',
  styles: [
  ]
})
export class Pf16Component implements AfterViewInit {

  @ViewChild('instructions') instructions: ElementRef;
 
  public formModel = {};
  public questions;
  public simQuestions = [];
  public isSim = true;
  public index;
  public texts;
  public testData;
  public photoTaked = false;
  public trigger = false;
  public instructionsReaded = false;
  public selectedQuestion:any={
    "title":"",
    "opcA":{"text":""},
    "opcB":{"text":""},
    "opcC":{"text":""},
  };
  
  public answers = [];

  public score = {
    "A":0,
    "B":0,
    "C":0,
    "D":0,
    "E":0,
    "F":0,
    "G":0,
    "H":0,
    "I":0,
    "L":0,
    "M":0,
    "N":0,
    "O":0,
    "Q1":0,
    "Q2":0,
    "Q3":0,
    "Q4":0,
  }
  public scoreConverted = {
    "A":0,
    "B":0,
    "C":0,
    "E":0,
    "F":0,
    "G":0,
    "H":0,
    "I":0,
    "L":0,
    "M":0,
    "N":0,
    "O":0,
    "Q1":0,
    "Q2":0,
    "Q3":0,
    "Q4":0,
  }

  constructor(private pf16:Pf16Service, private router: Router, private testService: TestService ) { 

    this.pf16.getSimQuestions().subscribe(
      resp=>{
        this.simQuestions = resp;
      },
      err=>console.log(err)
      )
      
    this.pf16.getQuestions().subscribe(
      resp=>{
        this.questions = resp.sort( (a, b) => {
          let titleA = a.title.trim();
          let titleB = b.title.trim();
          let numberA = Number(titleA.split('.')[0]);
          let numberB = Number(titleB.split('.')[0]);
          if (numberA < numberB) return -1;
          if (numberA > numberB) return 1;
          return 0;
        })
      },
      err=>console.log(err)
    )
      
    if(!this.testService.selectedTestData){
      this.router.navigateByUrl('dashboard/requestedTests');
    }
    this.testData = this.testService.selectedTestData;
  }

  ngOnInit(): void {

  }
  
  ngAfterViewInit(){
    if (this.testData.form){
      $('#formModal').modal('show');
    }
    this.testService.getTexts().subscribe(
      resp=>{
        this.texts = resp;
        setTimeout(()=>{
          this.instructions.nativeElement.innerHTML = this.texts.pf16Instructions;
        }, 500)
      },
      err=>console.log(err)
    )    
  }

  startSim(){
    this.isSim = true;
    this.index = 0;
    this.selectedQuestion = this.simQuestions[0];

  }

  startTest(){
    this.testService.testStarted = true;
    if (this.testData.camera){
      setTimeout(() => {
        this.trigger = !this.trigger;
      }, Math.floor(Math.random() * 60000 + 240000));
    }
    this.isSim = false;
    var testData = this.testService.selectedTestData;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();

    this.selectedQuestion = this.questions[0];
    this.index = 0;
    this.score = {
      "A":0,
      "B":0,
      "C":0,
      "D":0,
      "E":0,
      "F":0,
      "G":0,
      "H":0,
      "I":0,
      "L":0,
      "M":0,
      "N":0,
      "O":0,
      "Q1":0,
      "Q2":0,
      "Q3":0,
      "Q4":0,
    };

    this.scoreConverted = {
      "A":0,
      "B":0,
      "C":0,
      "E":0,
      "F":0,
      "G":0,
      "H":0,
      "I":0,
      "L":0,
      "M":0,
      "N":0,
      "O":0,
      "Q1":0,
      "Q2":0,
      "Q3":0,
      "Q4":0,
    };

    this.answers = [];
    
  }

  nextQuestion(){
    if (this.isSim){
      this.index = this.index + 1;
      this.selectedQuestion = this.simQuestions[this.index];
      if(!this.selectedQuestion){
        this.isSim = false;
        this.index = 0;
        Swal.fire('Simulación finalizada');
        $('#myModal').modal('hide');
        this.selectedQuestion = this.questions[0];
      }
    }else{     
      this.index = this.index + 1;
      this.selectedQuestion = this.questions[this.index];
      if(!this.selectedQuestion){
        this.trigger = !this.trigger;
        this.selectedQuestion = {
          "title":"Test finalizado",
          "opcA":{"text":"--"},
          "opcB":{"text":"--"},
          "opcC":{"text":"--"},
        }
        this.convertScore();
        Swal.fire({
          text:'Has concluido esta evaluación. Agradecemos tu participación',
          icon:'success',
          confirmButtonText:'Salir'
        });
        jQuery("#myModal").modal("hide");
        this.pf16.createReport(this.score, this.scoreConverted, this.answers).subscribe(
          res=>{
            var testData = this.testService.selectedTestData;
            let obj = {
              isCompleted:true,
              reportId:res._id,
              completeDate:Date.now(),
              _id:testData._id,
              evaluatedName:testData.evaluatedName,
              client:testData.client,
              type:testData.type
            }
            testData.isCompleted = true;
            testData.reportId = res._id;
            testData.completeDate = Date.now();
            this.testService.updateTest(obj).subscribe(
              r=>{
                this.router.navigateByUrl('dashboard/requestedTests');
              },
              e=>console.log(e)
            );
          },
          err=> console.log(err)
        )
        
      }
    }
  }

  convertScore(){
    
    if (this.score.A>=0&&this.score.A<=3) this.scoreConverted.A = 1;
    if (this.score.A>=4&&this.score.A<=5) this.scoreConverted.A = 2;
    if (this.score.A==6) this.scoreConverted.A = 3;
    if (this.score.A==7) this.scoreConverted.A = 4;
    if (this.score.A==8) this.scoreConverted.A = 5;
    if (this.score.A==9) this.scoreConverted.A = 6;
    if (this.score.A==10) this.scoreConverted.A = 7;
    if (this.score.A==11) this.scoreConverted.A = 8;
    if (this.score.A==12) this.scoreConverted.A = 9;
    if (this.score.B==0) this.scoreConverted.B = 1;
    if (this.score.B==1) this.scoreConverted.B = 2;
    if (this.score.B==2) this.scoreConverted.B = 3;
    if (this.score.B==3) this.scoreConverted.B = 4;
    if (this.score.B==4) this.scoreConverted.B = 6;
    if (this.score.B==5) this.scoreConverted.B = 7;
    if (this.score.B==6) this.scoreConverted.B = 9;
    if (this.score.C>=0&&this.score.C<=3) this.scoreConverted.C = 1;
    if (this.score.C>=4&&this.score.C<=5) this.scoreConverted.C = 2;
    if (this.score.C==6) this.scoreConverted.C = 3;
    if (this.score.C==7) this.scoreConverted.C = 4;
    if (this.score.C==8) this.scoreConverted.C = 5;
    if (this.score.C==9) this.scoreConverted.C = 6;
    if (this.score.C==10) this.scoreConverted.C = 7;
    if (this.score.C==11) this.scoreConverted.C = 8;
    if (this.score.C==12) this.scoreConverted.C = 9;
    if (this.score.E==0) this.scoreConverted.E = 1;
    if (this.score.E==1) this.scoreConverted.E = 2;
    if (this.score.E==2) this.scoreConverted.E = 3;
    if (this.score.E==3) this.scoreConverted.E = 4;
    if (this.score.E==4) this.scoreConverted.E = 5;
    if (this.score.E>=5&&this.score.E<=6) this.scoreConverted.E = 6;
    if (this.score.E==7) this.scoreConverted.E = 7;
    if (this.score.E>=8&&this.score.E<=9) this.scoreConverted.E = 8;
    if (this.score.E>=10&&this.score.E<=12) this.scoreConverted.E = 9;
    if (this.score.F>=0&&this.score.F<=2) this.scoreConverted.F = 1;
    if (this.score.F>=3&&this.score.F<=4) this.scoreConverted.F = 2;
    if (this.score.F==5) this.scoreConverted.F = 3;
    if (this.score.F==6) this.scoreConverted.F = 4;
    if (this.score.F==7) this.scoreConverted.F = 5;
    if (this.score.F==8) this.scoreConverted.F = 6;
    if (this.score.F==9) this.scoreConverted.F = 7;
    if (this.score.F==10) this.scoreConverted.F = 8;
    if (this.score.F>=11&&this.score.F<=12) this.scoreConverted.F = 9;
    if (this.score.G>=0&&this.score.G<=1) this.scoreConverted.G = 1;
    if (this.score.G>=2&&this.score.G<=3) this.scoreConverted.G = 2;
    if (this.score.G>=4&&this.score.G<=5) this.scoreConverted.G = 3;
    if (this.score.G==6) this.scoreConverted.G = 4;
    if (this.score.G==7) this.scoreConverted.G = 5;
    if (this.score.G==8) this.scoreConverted.G = 6;
    if (this.score.G>=9&&this.score.G<=10) this.scoreConverted.G = 7;
    if (this.score.G==11) this.scoreConverted.G = 8;
    if (this.score.G==12) this.scoreConverted.G = 9;
    if (this.score.G>=11&&this.score.G<=12) this.scoreConverted.G = 9;
    if (this.score.H>=0&&this.score.H<=3) this.scoreConverted.H = 1;
    if (this.score.H>=4&&this.score.H<=5) this.scoreConverted.H = 2;
    if (this.score.H==6) this.scoreConverted.H = 3;
    if (this.score.H==7) this.scoreConverted.H = 4;
    if (this.score.H==8) this.scoreConverted.H = 5;
    if (this.score.H==9) this.scoreConverted.H = 6;
    if (this.score.H==10) this.scoreConverted.H = 7;
    if (this.score.H==11) this.scoreConverted.H = 8;
    if (this.score.H==12) this.scoreConverted.H = 9;

    if (this.score.I>=11&&this.score.I<=12) this.scoreConverted.I = 1;
    if (this.score.I==10) this.scoreConverted.I = 2;
    if (this.score.I>=8&&this.score.I<=9) this.scoreConverted.I = 3;
    if (this.score.I==7) this.scoreConverted.I = 4;
    if (this.score.I>=5&&this.score.I<=6) this.scoreConverted.I = 5;
    if (this.score.I==4) this.scoreConverted.I = 6;
    if (this.score.I>=2&&this.score.I<=3) this.scoreConverted.I = 7;
    if (this.score.I==1) this.scoreConverted.I = 8;
    if (this.score.I==0) this.scoreConverted.I = 9;

    if (this.score.L>=11&&this.score.L<=12) this.scoreConverted.L = 1;
    if (this.score.L==10) this.scoreConverted.L = 2;
    if (this.score.L==9) this.scoreConverted.L = 3;
    if (this.score.L==8) this.scoreConverted.L = 4;
    if (this.score.L>=6&&this.score.L<=7) this.scoreConverted.L = 5;
    if (this.score.L==5) this.scoreConverted.L = 6;
    if (this.score.L==4) this.scoreConverted.L = 7;
    if (this.score.L>=2&&this.score.L<=3) this.scoreConverted.L = 8;
    if (this.score.L>=0&&this.score.L<=1) this.scoreConverted.L = 9;

    if (this.score.M>=11&&this.score.M<=12) this.scoreConverted.M = 1;
    if (this.score.M>=9&&this.score.M<=10) this.scoreConverted.M = 2;
    if (this.score.M==8) this.scoreConverted.M = 3;
    if (this.score.M==7) this.scoreConverted.M = 4;
    if (this.score.M==6) this.scoreConverted.M = 5;
    if (this.score.M==5) this.scoreConverted.M = 6;
    if (this.score.M>=3&&this.score.M<=4) this.scoreConverted.M = 7;
    if (this.score.M==2) this.scoreConverted.M = 8;
    if (this.score.M>=0&&this.score.M<=1) this.scoreConverted.M = 9;

    if (this.score.N>=0&&this.score.N<=1) this.scoreConverted.N = 1;
    if (this.score.N==2) this.scoreConverted.N = 2;
    if (this.score.N==3) this.scoreConverted.N = 3;
    if (this.score.N==4) this.scoreConverted.N = 4;
    if (this.score.N==5) this.scoreConverted.N = 5;
    if (this.score.N==6) this.scoreConverted.N = 6;
    if (this.score.N==7) this.scoreConverted.N = 7;
    if (this.score.N>=8&&this.score.N<=9) this.scoreConverted.N = 8;
    if (this.score.N>=11&&this.score.N<=12) this.scoreConverted.N = 9;

    if (this.score.O>=9&&this.score.O<=12) this.scoreConverted.O = 1;
    if (this.score.O>=7&&this.score.O<=8) this.scoreConverted.O = 2;
    if (this.score.O==6) this.scoreConverted.O = 3;
    if (this.score.O==5) this.scoreConverted.O = 4;
    if (this.score.O==4) this.scoreConverted.O = 5;
    if (this.score.O==3) this.scoreConverted.O = 6;
    if (this.score.O==2) this.scoreConverted.O = 7;
    if (this.score.O==1) this.scoreConverted.O = 8;
    if (this.score.O==0) this.scoreConverted.O = 9;

    if (this.score.Q1==0) this.scoreConverted.Q1 = 1;
    if (this.score.Q1==1) this.scoreConverted.Q1 = 2;
    if (this.score.Q1>=2&&this.score.Q1<=3) this.scoreConverted.Q1 = 3;
    if (this.score.Q1==4) this.scoreConverted.Q1 = 4;
    if (this.score.Q1==5) this.scoreConverted.Q1 = 5;
    if (this.score.Q1>=6&&this.score.Q1<=7) this.scoreConverted.Q1 = 6;
    if (this.score.Q1==8) this.scoreConverted.Q1 = 7;
    if (this.score.Q1>=9&&this.score.Q1<=10) this.scoreConverted.Q1 = 8;
    if (this.score.Q1>=11&&this.score.Q1<=12) this.scoreConverted.Q1 = 9;

    if (this.score.Q2>=0&&this.score.Q2<=3) this.scoreConverted.Q2 = 1;
    if (this.score.Q2>=4&&this.score.Q2<=5) this.scoreConverted.Q2 = 2;
    if (this.score.Q2==6) this.scoreConverted.Q2 = 3;
    if (this.score.Q2==7) this.scoreConverted.Q2 = 4;
    if (this.score.Q2==8) this.scoreConverted.Q2 = 5;
    if (this.score.Q2==9) this.scoreConverted.Q2 = 6;
    if (this.score.Q2==10) this.scoreConverted.Q2 = 7;
    if (this.score.Q2==11) this.scoreConverted.Q2 = 8;
    if (this.score.Q2==12) this.scoreConverted.Q2 = 9;

    if (this.score.Q3>=0&&this.score.Q3<=3) this.scoreConverted.Q3 = 1;
    if (this.score.Q3>=4&&this.score.Q3<=5) this.scoreConverted.Q3 = 2;
    if (this.score.Q3==6) this.scoreConverted.Q3 = 3;
    if (this.score.Q3==7) this.scoreConverted.Q3 = 4;
    if (this.score.Q3==8) this.scoreConverted.Q3 = 5;
    if (this.score.Q3==9) this.scoreConverted.Q3 = 6;
    if (this.score.Q3==10) this.scoreConverted.Q3 = 7;
    if (this.score.Q3==11) this.scoreConverted.Q3 = 8;
    if (this.score.Q3==12) this.scoreConverted.Q3 = 9;

    if (this.score.Q4>=11&&this.score.Q4<=12) this.scoreConverted.Q4 = 1;
    if (this.score.Q4>=9&&this.score.Q4<=10) this.scoreConverted.Q4 = 2;
    if (this.score.Q4==8) this.scoreConverted.Q4 = 3;
    if (this.score.Q4>=6&&this.score.Q4<=7) this.scoreConverted.Q4 = 4;
    if (this.score.Q4==5) this.scoreConverted.Q4 = 5;
    if (this.score.Q4==4) this.scoreConverted.Q4 = 6;
    if (this.score.Q4==3) this.scoreConverted.Q4 = 7;
    if (this.score.Q4==2) this.scoreConverted.Q4 = 8;
    if (this.score.Q4>=0&&this.score.Q4<=1) this.scoreConverted.Q4 = 9;

  }

  select(opc){
    this.answers.push(opc);
    if (opc==='A'){
      for (let f in this.score){
        if (String(f)===String(this.selectedQuestion.factor)){
          this.score[f] = this.score[f]+this.selectedQuestion.opcA.value;
          
        }
      }
    }

    if (opc==='B'){
      for (let f in this.score){
        if (String(f)===String(this.selectedQuestion.factor)){
          this.score[f] = this.score[f]+this.selectedQuestion.opcB.value;
          
        }
      }
    }

    if (opc==='C'){
      for (let f in this.score){
        if (String(f)===String(this.selectedQuestion.factor)){
          this.score[f] = this.score[f]+this.selectedQuestion.opcC.value;
          
        }
      }
    }
    this.nextQuestion();
    
  }

  nextInstructions(){
    this.instructionsReaded=true;
    setTimeout(()=>{
      this.instructions.nativeElement.innerHTML = this.texts.pf16Instructions2;
    }, 500);

  }

  sendForm(){
    let obj = {
      _id:this.testService.selectedTestData._id,
      formData:this.formModel
    }
    this.testService.updateTest(obj).subscribe(
      resp=>{
        $('#formModal').modal('hide');
      },
      err=>console.log(err)
    );
  }

  reload(){
    location.reload()
  }

}
